/* ImageDropZone.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _8 = "._19pk12gs{margin-top:-2px}";
const _7 = "._19bvidpf{padding-left:0}";
const _6 = "._n3tdidpf{padding-bottom:0}";
const _5 = "._u5f3idpf{padding-right:0}";
const _4 = "._ca0qidpf{padding-top:0}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Button from '@atlaskit/button';
import { ErrorMessage, HelperMessage } from '@atlaskit/form';
import UploadIcon from '@atlaskit/icon/glyph/upload';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';
// eslint-disable-next-line @atlaskit/design-system/no-unsupported-drag-and-drop-libraries
import { useDropzone } from 'react-dropzone';
import ImageDropZonePreview from './ImageDropZonePreview';
import { IMAGE_FIELD_DROP_ZONE_CONTENT, IMAGE_FIELD_DROP_ZONE_INPUT, IMAGE_FIELD_DROP_ZONE_SPINNER } from './testIds';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _3 = "._y3gn1h6o{text-align:center}";
const _2 = "._1wyb1crf{font-size:9pt}";
const _ = "._syaz131l{color:var(--ds-text-subtlest,#626f86)}";
const GreyText = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz131l _1wyb1crf _y3gn1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  GreyText.displayName = 'GreyText';
}
const LinkButton = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = Button,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _5, _6, _7, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pk12gs", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LinkButton.displayName = 'LinkButton';
}
const dragBoxStyles = xcss({
  width: '100%',
  height: '180px',
  border: "2px dashed ".concat("var(--ds-border, #091E4224)"),
  borderRadius: 'radius.xlarge',
  paddingTop: 'space.500',
  paddingBottom: 'space.500',
  justifyContent: 'center',
  display: 'flex'
});
const dragBoxActiveStyles = xcss({
  border: "2px dashed ".concat("var(--ds-text-selected, #0C66E4)")
});
const dragBoxPreviewStyles = xcss({
  padding: 'space.0',
  border: 'none'
});
const dragFlexStyles = xcss({
  width: '200px'
});
const ImageDropZone = props => {
  const {
    helperMessage,
    imageUploading,
    errorMessage,
    handleFileChange,
    url,
    isDisabled
  } = props;
  const onDrop = files => handleFileChange(files);
  const {
    isDragActive,
    getRootProps,
    getInputProps
  } = useDropzone({
    onDrop,
    disabled: imageUploading
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
      xcss: [dragBoxStyles, isDragActive && dragBoxActiveStyles, url !== null && url !== void 0 && url.imageUrl ? dragBoxPreviewStyles : false]
    }, getRootProps()), {}, {
      children: [/*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({}, getInputProps()), {}, {
        "data-testid": IMAGE_FIELD_DROP_ZONE_INPUT,
        disabled: isDisabled,
        multiple: false
      })), (url === null || url === void 0 ? void 0 : url.imageUrl) && /*#__PURE__*/_jsx(ImageDropZonePreview, _objectSpread({}, props)), !(url !== null && url !== void 0 && url.imageUrl) && /*#__PURE__*/_jsxs(Flex, {
        direction: "column",
        alignItems: "center",
        gap: "space.150",
        xcss: dragFlexStyles,
        testId: IMAGE_FIELD_DROP_ZONE_CONTENT,
        children: [imageUploading && /*#__PURE__*/_jsx(Spinner, {
          testId: IMAGE_FIELD_DROP_ZONE_SPINNER,
          interactionName: "load",
          label: "Loading",
          size: "large"
        }), !imageUploading && /*#__PURE__*/_jsx(UploadIcon, {
          label: "upload",
          size: "xlarge",
          primaryColor: "var(--ds-text-subtlest, #626F86)"
        }), /*#__PURE__*/_jsxs(GreyText, {
          children: ["Drag and drop .png or .jpg image or upload from computer", ' ', /*#__PURE__*/_jsx(LinkButton, {
            appearance: "link",
            children: "here"
          })]
        })]
      })]
    })), errorMessage && /*#__PURE__*/_jsx(ErrorMessage, {
      children: errorMessage
    }), helperMessage && /*#__PURE__*/_jsx(HelperMessage, {
      children: helperMessage
    })]
  });
};
export default ImageDropZone;